const en = require('./en.json')
export default en;
// export default {
//   forms: {
//     inputLoginPlaceholed: 'Login or Email',
//     passwordLabel: 'Password',
//     oldPasswordLabel: 'Enter previous password',
//     newPasswordLabel: 'New password',
//     repeatPasswordPl: 'Confirm password',
//     restore: 'Forgot your password?',
//     namePl: 'Name',
//     nameLb: 'Name',
//     groupPl: 'NASA',
//     surnamePl: 'Surname',
//     surnameLb: 'Surname',
//     email: 'E-mail',
//     emailLb: 'Email',
//     telPl: 'Telephone',
//     telLb: 'Phone number',
//     cityLb: 'City',
//     cityPl: 'Moscow',
//     provinceLb: 'Region',
//     provincePl: 'Moscow',
//     countryLb: 'Country',
//     countryPl: 'UK',
//     postalCodeLb: 'Postal code',
//     postalCodePl: '123456',
//     lang: 'Interface language',
//     descLb: 'Description',
//     descPl: 'Text',
//     postalLb: 'Postal code',
//     addressLb: 'Address',
//     userList: 'Users list',
//     fullscreen: 'Always full screen',
//     searchAddressLb: 'Enter your address',
//     searchAddressPl: 'NY, Lenina street',
//     notRobot: 'I am not a robot',
//     groupPhoto: 'Group photo',
//     userPhoto: 'User photo',
//     uploadPhotoLabel: 'Upload photo',
//     notFound: 'Not found'
//   },
//   btns: {
//     enter: 'Sign in',
//     reg: 'Sign up',
//     add: "Add",
//     accept: 'Accept',
//     cancel: "Cancel",
//     changePass: 'Change password',
//     create: 'Create',
//     send: 'Send',
//     save: 'Save',
//     success: 'Data updated',
//     users: {
//       group: 'User group',
//       user: 'User',
//       controlUsers: 'User management',
//       controlThings: 'Things management',
//       controlDashboards: 'Dashboard management',
//       delUser: 'Delete',
//       copyBtn: 'Copy User ID',
//       showActivatonLink: 'Display activation link',
//       repeatActivation: 'Repeat activation',
//       enterAsUser: 'Log in as a customer users',
//       toGroup: 'Go to group',
//       editGroup: 'Edit',
//       editUser: 'Edit',
//       vidgets: 'Widgets',
//       things: 'Things',
//       delGroup: 'Delete',
//     },
//     things: {
//       new: 'Create a new thing',
//       import: 'Import item'
//     }
//   },
//   labels: {
//     or: 'or',
//     coped: 'Text copied'
//   },
//   errors: {
//     standard: 'Please fill in the field',
//     email: 'Please enter a valid e-mail',
//     passLength: 'Password cannot be shorter',
//     passLength1: 'characters',
//     passDouble: 'Passwords do not match',
//     telLength: 'The phone cannot be shorter than',
//     telLength1: 'numbers',
//     fileSize: 'Not more than ',
//     fileSizeMB: 'MB',
//     wrongPass: 'Wrong password!',
//     mailFalse: 'Email is already taken',
//     leaveConfirm: 'Changes were not saved. Leave the page?'
//   },
//   menu: {
//     home: 'Home',
//     scripts: 'Scripts',
//     users: 'Users',
//     things: 'Things',
//     vidgets: 'Widgets',
//     dashboards: 'Dashboards',
//     logs: 'Action logs',
//     logout: 'Logout',
//     switchSidebar: 'Switch to sidebar',
//     search: 'Search',
//     submenu: {
//       journal: 'Logbook',
//       profile: 'My profile'
//     },
//     lang: 'Language'
//   },
//   popups: {
//     delConfirm: {
//       title: 'Are you sure you want to delete',
//     },
//     addUser: {
//       title: 'Create users',
//       mailLb: 'Email',
//     },
//     addUserGroup: {
//       title: 'Create users group',
//       nameLb: 'Group name*',
//     },
//     showMoreUser: {
//       sec1: "Details",
//       sec2: 'Action history'
//     },
//     setUserGroup: {
//       title: 'Choose users',
//       btn: 'Attach users'
//     }
//   },
//   index: {
//     scripts: {
//       title: "Scripts",
//       desc: 'Script management'
//     },
//     users: {
//       title: 'Users',
//       desc: 'users rights management'
//     },
//     things: {
//       title: 'Things',
//       desc: 'Stuff management'
//     },
//     widgets: {
//       title: 'Widgets',
//       desc: 'Widget management'
//     },
//     dashboard: {
//       title: 'Dashboards',
//       desc: 'Dashboard management'
//     },
//     logs: {
//       title: 'Action logs',
//       desc: 'Manage action logs'
//     },
//     journal: {
//       title: 'Logbook',
//       desc: 'Events, things, notes'
//     }
//   },
//   login: {
//     title: 'Sign in',
//     regText: 'Don\'t have an account?',
//     regLink: 'Sign up',
//     recoveryTitle: 'Restore password',
//     recoveryText: 'The letter was sent to the mail'
//   },
//   registration: {
//     title: 'Registration',
//     acceptText: 'I accept',
//     acceptLink: 'privacy policy',
//     loginText: 'Already have an account?',
//     loginLink: 'Sign in'
//   },
//   profile: {
//     infoTitle: 'Basic information',
//     dopTitle: 'Additional information',
//     passTitle: 'Change password',
//     statuses: {
//       admin: 'Administrator'
//     },
//     successPass: 'Password changed successfully'
//   },
//   users: {
//     user: 'User',
//     group: 'Users group',
//     createFaceless: 'Create anonymous users',
//     filter: {
//       title: 'Filter by: ',
//       all: 'Users and groups',
//       user: 'Users',
//       group: 'Groups',
//       empty: 'Unattached Users'
//     }
//   }
// }
